export default __webpack_public_path__ + "static/media/logo_msn.6ed6ae31.svg";